import { PublicClientApplication } from "@azure/msal-browser";
import { stringOrEmpty } from "utils/utils";

const msalConfig = {
  auth: {
    navigateToLoginRequestUrl: true,
    clientId: stringOrEmpty(process.env.REACT_APP_AZURE_FRONT_CLIENT_ID),
    redirectUri: stringOrEmpty(process.env.REACT_APP_AZURE_FRONT_REDIRECT_URI),
    postLogoutRedirectUri: stringOrEmpty(
      process.env.REACT_APP_AZURE_FRONT_POST_LOGOUT_REDIRECT_URI
    ),
    authority: `https://login.microsoftonline.com/${stringOrEmpty(
      process.env.REACT_APP_AZURE_TENANT_ID
    )}`,
  },
  cache: {
    storeAuthStateInCookie: true,
    cacheLocation: "localStorage",
  },
};

// Login request user have to re-sign-in on App-kill
const loginRequest = {
  prompt: "select_account",
  scopes: [stringOrEmpty(process.env.REACT_APP_AZURE_SCOPE_API)],
  
};

// Error handeling
const errorLoginRequest = {
  prompt: "login",
  scopes: [stringOrEmpty(process.env.REACT_APP_AZURE_SCOPE_API)],
};

const msalInstance = new PublicClientApplication(msalConfig);

export { msalInstance, loginRequest, errorLoginRequest };
